module.exports = __webpack_public_path__ + "media/images/proffile_activity-7c30e2bfcee027ba36c2b74ed9cc0f8a.svg";